import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 取消集保(TDCC)授權回應
 */
export interface IRemoveTxIDResponse {
    /** 回應狀態 */
    status: boolean;
    /** 訊息 */
    message: string | null;
}

/**
 * 集保(TDCC) - 取消集保授權（全域取消，清除 Session 中的 TxID）
 *
 * @description 呼叫後端清除 Session 中的集保 TxID，所有 ItemID 同時取消授權
 * @returns Promise<IRemoveTxIDResponse>
 */
export async function RemoveTxID(): Promise<IRemoveTxIDResponse> {
    const url = RouteUrlList.API_TdccRemoveTxID.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return await ApiClient.post(
        url,
        {},
        config
    ).then((res: AxiosResponse<IRemoveTxIDResponse>) => {
        return res.data;
    });
}

export default RemoveTxID;
